
import React from 'react';
export default function Blog013() {
  return (
    <section>
    <article>
      <h2>13. 08-31-2022</h2>
      <h3>My First Portfolio and Project</h3>
      <p> 
             Hey! It has been a few days since the last update on this blog, and a lot has taken place during these days. 
             I'm going to bullet point everything out as an index to make sure I write about everything.
             </p>
             <ul>
              <li>Updating websites and domains</li>
              <li>Notebook of Ideas</li>
              <li>Recording Video: When and When Not</li>
              <li>'My Friendly Computer' Game</li>
              <li>Javascript Buttons</li>
              <li>My new Portfolio Website</li>
              <li>Two Month Recap</li>
             </ul>
             <p>
              <br />
              <br /><strong>Updating websites and domains</strong><br />
              I am in the middle of creating a primary website. I have established the url <a className="offwhite" href="http://www.ericpolley.com">ericpolley.com</a> . I am currently linking
               all the pages to the portfolio. So currently there are a few minor bugs to work out, mostly cosmetics. 
              <br />
              
              <br /><strong>Notebook of Ideas</strong><br />

              I have a few notebooks with notes I have accumulated over learning HTML, CSS, and Javascript. I have also started a notebook with a few coding ideas.
               Some of these ideas are a few images and templates. Some of these ideas are the start to a fully developed game. I like the idea of storing my ideas for 
              future projects. This will make it easier to pair program as well, having a few ideas to pull out of a notebook can reduce start time. 
              <br />
              <br /><strong>Recording Video</strong><br />
              I don't want to talk about making videos, as much as I would like to talk about when I should or should not make videos. Really, I need to be realistic with 
              the priority level of making these videos. Yes, creating these videos may help me with my career in the future, but my priority is coding and learning programming. 
              The noticed when I started recording my coding progress on the 'my friendly computer' game, that I would not work on it unless I was recording video. 


              <br />
              <br /><strong>'My Friendly Computer' Game</strong><br />
              I have been working on the 'My Friendly Computer' for a bit more than a week. 
              This is the project I was referring to with creating coding videos on my progress. 
              I was giving myself an obstacle of obligation. After I realized that and 
              just finished it on my own terms, everything starting moving relatively smoothly.
               I enjoyed completeing this game, it is now the only project in 
               my current portfolio. I linked the game in the post links below, 
                if you would like to give it a try for yourself. 

              <br />
              <br /><strong>Javascript Buttons</strong><br />
              I have learned a lot with Javascript, my focus has been manipulating the DOM.
              I titled this post Javascript Buttons, but with addEventListener and classNameList you can do so 
              much more than buttons. If it is, then it can also Javascript. 

              <br />
              <br /><strong>My new Portfolio Website</strong><br />
              I have created a portfolio landing page, hosted it on github,
               and applied a domain from goDaddy. I have a lot to learn when it comes to hosting a website. 
               Currently the website only works with the cname: www. 
               So, www.ericpolley.com works. ericpolley.com does not. 

              <br />
              <br /><strong>Two Month Recap</strong><br />
              I have recorded the 8 week/2month vlog and uploaded to youtube. 
              I added a link in the links below. I mostly talk about my new website and 
              the 'My Friendly Computer' Game. 
             

            
              
             
      </p> 
    </article>
    <h4>Links</h4>
    <br />
    <ul>

      <li>
        <a
          href="http://my.ericpolley.com/"
          title="My friendly Computer"
          target="_blank"
          rel="noopener noreferrer" 
        >
          <strong><p>'My Friendly computer' Game</p></strong></a
        >
      </li>
      
      <li>
        <a
          href="http://www.ericpolley.com"
          title="Check out my new website!"
          target="_blank"
          rel="noopener noreferrer" 
        >
          <strong><p>Check out my website</p></strong></a
        >
      </li>
    

    <li>
      <a
        href="https://www.youtube.com/watch?v=VHsE-cRypq4&list=PLce5_YZyrUw7dNEL7F1T4kxAp0mMuattO"
        title="VLOG"
        target="_blank"
        rel="noopener noreferrer" 
      >
        <strong><p>VLOG Video series</p></strong></a
      >
    </li>
    </ul>
  </section>
  )
}
